import { createSlice } from "@reduxjs/toolkit";
import { localeShow, url } from "../../constants/lang";

const changeLang = createSlice({
  name: "type",
  initialState: {
    language: null,
    change: localeShow.find((item) => item.includes(url.slice(1, 3))) || "en",
  },
  reducers: {
    resetLang(state, { payload }) {
      state.language = payload;
    },
    setLocale(state, { payload }) {
      state.change = payload;
    },
  },
});
export const { resetLang, setLocale } = changeLang.actions;

export const fetchLanguage = () => async (dispatch) => {
  const getLang = () =>
    localeShow.find((item) => item.includes(url.slice(1, 3))) || "en";
  const language = await import(`../../constants/languages/${getLang()}.json`);
  dispatch(changeLang.actions.resetLang(language));
};

export default changeLang.reducer;
